import { gql } from '@apollo/client';

export const totp2FARequiredForEmailLoginsQuery = gql`
query totp2FARequiredForEmailLogins {
  totp2FARequiredForEmailLogins  {
    totp2faRequired
  }
}
`;
